import axiosInstance from './axios';

const LocationAPI = {

    getListOfPlaces : () => {
        return axiosInstance.get('places', { });
    },

    //----------------------------------------------------------------
    getListOfSubplaces : (place_id) => {
        return axiosInstance.get(`subplaces/${place_id}`, { });
    },
    //----------------------------------------------------------------
    getListOfLocations : (subplace_id) => {
        return axiosInstance.get(`locations/${subplace_id}`, { });
    },
    //----------------------------------------------------------------
    // the first request for a location has the server find it on a public map
    // service by name, which takes longer than the default timeout
    getLocationCoordinates : (location_id) => {
        return axiosInstance.get(`location/coordinates/${location_id}`, { timeout: 20000 });
    },
    //----------------------------------------------------------------
    // the server asks a public map service, which can take half a minute on
    // the first request for an area, far longer than the default timeout
    // the places near a listing are found ahead and come with it; this is for
    // one whose places are not found yet, which takes the server up to a minute
    getNearby : (listing_id) => {
        return axiosInstance.get(`nearby/listing/${listing_id}`, { timeout: 90000 });
    },
    //----------------------------------------------------------------
    getAmenities : (type, lat, lon, distance) => {
        return axiosInstance.get(`${type}/${lat}/${lon}/${distance}`, { timeout: 90000 });
    },
    //----------------------------------------------------------------
    getTreeLocations : (place_id) => {
        return axiosInstance.get(`tree/locations/${place_id}`, { });
    },
    //----------------------------------------------------------------
    // cities, parts of a city and locations whose name matches the text
    searchAreas : (query) => {
        return axiosInstance.get('areas/search', { params: { q: query } });
    }


}

export default LocationAPI;